<div class="custom-tree-chart">
    <div class="icon clearfix" (click)="toggleTreeChart($event)">
        <i class='fa fa-angle-right'>
        </i>
        <div class='peices'>
        </div>
        <div class='peices'>
        </div>
        <div class='peices'>
        </div>
        <i class='fa fa-angle-left'>
        </i>
    </div>
    <div class="nodes" tabindex="-1">
        @for (node of options.data.nodes | orderBy : '-width'; track $index; let index = $index) {
<div class="tree-node" style="cursor:pointer"
            title="{{node.name}} : {{node.value | convertAmount : '$'}}"
            [ngClass]="{'fade-opacity' : !node.selected && !initialHighlighted}"
            [ngStyle]="{'width.px' : node.width , 'background-color': node.color}" (click)="nodeClicked($event,node)" id="{{'node-'+ index}}">
            <p class="node-details">{{node.name}}</p>
            <p class="node-details ">{{node.value | convertAmount : '$'}}</p>
        </div>
}
    </div>
</div>
